import React, { FC } from 'react';

export const PoliceIcon: FC<any> = ({ stroke = '#fff', ...props }) => (
  <svg {...props} height="22" viewBox="0 0 12.344 23.846" width="12.344" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(0.149 0.5)">
      <g id="svg_11">
        <path
          d="M185.274,162.886l-2.436.1-.1.994a1.745,1.745,0,0,0,1.6,1.931,1.57,1.57,0,0,0,1.405-1.038C186,164.262,185.682,162.886,185.274,162.886Zm1.355.9"
          fill="none"
          id="svg_8"
          stroke={stroke}
          strokeWidth="0.5"
          transform="translate(-178.48 -159.157)"
        />
        <path
          d="M182.518,162.377v.279c0,.331.7.762,1.564.762s1.564-.431,1.565-.762v-.279a1.074,1.074,0,0,0,.579-.357.7.7,0,0,0,.131-.427,1.462,1.462,0,0,0-.7-1.1,2.753,2.753,0,0,0-3.157,0,1.462,1.462,0,0,0-.7,1.1.7.7,0,0,0,.132.427,1.074,1.074,0,0,0,.579.356Zm1.564-.844c.146,0,.31.22.31.515s-.164.514-.31.514-.31-.22-.31-.514S183.936,161.533,184.083,161.533Zm0,0"
          fill="none"
          id="svg_9"
          stroke={stroke}
          strokeWidth="1"
          transform="translate(-178.518 -160)"
        />
        <path
          d="M187.122,172.557l2.581-.642a.7.7,0,0,0,.593-.879l-1.022-2.708a2.832,2.832,0,0,0-2.7-1.585h-.62a3.2,3.2,0,0,1-.957,1.751l.1-.376a.075.075,0,0,0,0-.038l-.118-.473a.117.117,0,0,0-.118-.076h-.454a.117.117,0,0,0-.118.076l-.118.473a.075.075,0,0,0,0,.038l.1.376a3.2,3.2,0,0,1-.957-1.751h-.556a2.832,2.832,0,0,0-2.7,1.585l-1.022,2.708a.7.7,0,0,0,.593.879l2.5.627c0,1.026,0,7.972,0,8.332a1.164,1.164,0,0,0,2.262,0V173.79h.478v7.082a1.163,1.163,0,0,0,2.261,0c0-.377-.013-7.329-.014-8.313v0Zm0-1.494v-2.771a1.028,1.028,0,0,1,.16.1h0a.791.791,0,0,1,.261.339l.77,2.039-1.171.292-.02,0v-.005Zm-4.973-.011-1.128-.281.77-2.039a.825.825,0,0,1,.358-.406Zm0,0"
          fill="none"
          id="svg_10"
          stroke={stroke}
          strokeWidth="1"
          transform="translate(-178.644 -158.916)"
        />
      </g>
    </g>
  </svg>
);
